export const i19about = 'Sobre nós'
export const i19aboutCvvMsg = '3 ou 4 dígitos, geralmente no verso do cartão (na frente em cartões AMEX)'
export const i19acceptAttachedFile = 'Aceitar arquivo em anexo'
export const i19acceptCustomOptionByCustomer = 'Aceitar opção personalizada pelo cliente'
export const i19activate = 'Ativar'
export const i19active = 'Ativo'
export const i19add = 'Adicionar'
export const i19addApp = 'Adicionar aplicativo'
export const i19addCart = 'Adicionar carrinho'
export const i19addClient = 'Adicionar Cliente'
export const i19addDiscountCoupon = 'Adicionar cupom de desconto'
export const i19addGiftList = 'Adicionar lista de presente'
export const i19addGrid = 'Adicionar grade'
export const i19additional = 'Adicional'
export const i19additionalCost = 'Custo adicional'
export const i19additionalCostOption = 'Custo adicional da opção'
export const i19address = 'Endereço'
export const i19addresses = 'Endereços'
export const i19addressesName = 'Destinatário'
export const i19addMoreProducts = 'Adicionar mais produtos'
export const i19addPreference = 'Adicionar aos desejos'
export const i19addToCart = 'Adicionar ao carrinho'
export const i19addToPrice = 'Adicionar preço'
export const i19addVariants = 'Adicionar variações'
export const i19add$1ToEarn = 'Adicione $1 para ganhar'
export const i19adminSettings = 'Configurações no painel'
export const i19adRelevance = 'Relevância do anúncio'
export const i19adType = 'Tipo de anúncio'
export const i19advanced = 'Avançado'
export const i19adwords = 'Adwords'
export const i19adwordsRemarketing = 'Adwords remarketing'
export const i19adwordsRemarketingCode = 'Código de Remarketing do AdWords'
export const i19affiliateCoede = 'Código do afiliado'
export const i19afterApproval = 'Após pedido aprovado'
export const i19afterPayment = 'Após pagamento'
export const i19allCategories = 'Todas categorias'
export const i19alt = 'Tag alt'
export const i19amount = 'Montante'
export const i19another = 'Outro'
export const i19api = 'Api'
export const i19app = 'Aplicativo'
export const i19appConfiguration = 'Configuração do aplicativo'
export const i19apps = 'Aplicativos'
export const i19appDevelopers = 'Desenvolvedor de aplicativos'
export const i19application = 'Aplicação'
export const i19applications = 'Aplicações'
export const i19applyDiscount = 'Aplicar desconto'
export const i19areYouWantToDeleteAppQn = 'Tem certeza que deseja excluir o aplicativo?'
export const i19associateImage = 'Associar imagem'
export const i19associateImages = 'Associar imagens'
export const i19asOf = 'A partir de'
export const i19at = 'Em'
export const i19atSight = 'À vista'
export const i19attachment = 'Anexar'
export const i19attention = 'Atenção'
export const i19authentication = 'Autenticação'
export const i19author = 'Autor'
export const i19authorizedStores = 'Lojas autorizadas'
export const i19automaticallyTrackInventory = 'Controle automático de estoque'
export const i19available = 'Disponível'
export const i19availablePurchase = 'Disponível para compra'
export const i19availableApps = 'Aplicativos disponíveis'
export const i19back = 'Voltar'
export const i19backToCart = 'Voltar ao carrinho'
export const i19backToProduct = 'Voltar ao produto'
export const i19bag = 'Sacola'
export const i19banner = 'Banner'
export const i19banners = 'Banners'
export const i19bannersCollection = 'Banners da Coleção'
export const i19barcodes = 'Código de barras'
export const i19basePrice = 'Preço base'
export const i19best = 'Melhor'
export const i19bestSellers = 'Mais vendidos'
export const i19birthdate = 'Data de nascimento'
export const i19billingAddress = 'Endereço de cobrança'
export const i19block = 'Bloquear'
export const i19borough = 'Bairro'
export const i19budgetOnly = 'Apenas orçamento'
export const i19buy = 'Comprar'
export const i19buyAgain = 'Comprar novamente'
export const i19buyAlsoMsg = 'Aproveite e leve também'
export const i19buyer = 'Comprador'
export const i19buyers = 'Compradores'
export const i19buyNow = 'Comprar agora'
export const i19by = 'Por'
export const i19brand = 'Marca'
export const i19brandBanners = 'Banners da marca'
export const i19brandName = 'Nome da marca'
export const i19brandFound = 'Marca encontrada'
export const i19brands = 'Marcas'
export const i19brandsFound = 'Marcas encontradas'
export const i19brazil = 'Brasil'
export const i19browserIp = 'Ip do browser'
export const i19buyWith = 'Comprar Juntos'
export const i19calculateShipping = 'Calcular frete'
export const i19callTo = 'Ligue para'
export const i19callback = 'Callback'
export const i19campaign = 'Campanha'
export const i19campaignAppliedMsg = 'Campanha de desconto aplicada com sucesso.'
export const i19cancel = 'Cancelar'
export const i19cancelled = 'Cancelado'
export const i19cancelledAt = 'Cancelado em'
export const i19cancelOrder = 'Cancelar pedido'
export const i19cancelReason = 'Motivo do cancelamento'
export const i19cardNumber = 'Número do cartão'
export const i19cartConfirmed = 'Carrinho confirmado'
export const i19cartDetails = 'Detalhes do carrinho'
export const i19cartItems = 'Itens do Carrinho'
export const i19cartReview = 'Revisar carrinho'
export const i19categories = 'Categorias'
export const i19category = 'Categoria'
export const i19categoryBanners = 'Banner da categoria'
export const i19categoryFound = 'Categoria encontrada'
export const i19categoryName = 'Nome da categoria'
export const i19cellphone = 'Celular'
export const i19changePaymentMethod = 'Alterar forma de pagamento'
export const i19changeShippingMethod = 'Alterar forma de envio'
export const i19channel = 'Canal'
export const i19channelId = 'ID do canal'
export const i19channels = 'Canais'
export const i19channelType = 'Tipo de canal'
export const i19checkout = 'Finalizar compra'
export const i19checkoutEnabled = 'Checkout habilitado'
export const i19checkoutDone = 'Checkout finalizado'
export const i19checkoutLink = 'Link do checkout'
export const i19checkoutMobileLink = 'Link do checkout para mobile'
export const i19checkoutVisitor = 'Visitante do checkout'
export const i19checkoutVisitorMsg = 'Você também pode comprar como visitante se preferir'
export const i19city = 'Cidade'
export const i19clearFilters = 'Limpar filtros'
export const i19click = 'Clicar'
export const i19clickHere = 'Click aqui'
export const i19close = 'Fechar'
export const i19closedAt = 'Fechado em'
export const i19closeFilters = 'Fechar filtros'
export const i19code = 'Código'
export const i19codeCopied = 'Código copiado'
export const i19collection = 'Coleção'
export const i19collections = 'Coleções'
export const i19collectionBanners = 'Banner da coleção'
export const i19collectionItems = 'Itens da coleção'
export const i19collectionName = 'Nome da coleção'
export const i19color = 'Cor'
export const i19colors = 'Cores'
export const i19community = 'Comunidade'
export const i19companyRegistration = 'Pessoa jurídica'
export const i19compareAtPrice = 'Compare ao preço'
export const i19compareProducts = 'Produtos Similares'
export const i19complement = 'Complemento'
export const i19complementInformation = 'Informação complementar'
export const i19connectionErrorMsg = 'Erro de conexão, tente novamente'
export const i19connectionErrorProductMsg = 'Erro de conexão, clique no produto para tentar novamente'
export const i19configuration = 'Configuração'
export const i19confirmPassword = 'Confirmar senha'
export const i19confirmPurchase = 'Confirmar compra'
export const i19contactPhone = 'Telefone de contato'
export const i19contactUsMsg = 'Se houver alguma dúvida entre em contato conosco.'
export const i19content = 'Conteúdo'
export const i19continue = 'Continuar'
export const i19continueLoginOnPopup = 'Continue o login na popup'
export const i19continueShopping = 'Continuar comprando'
export const i19control = 'Controle'
export const i19copyCode = 'Copiar código'
export const i19copyErrorMsg = 'Erro ao copiar para a área de transferência, por favor copie manualmente'
export const i19copyright = 'Copyright'
export const i19corporateName = 'Razão sozial da empresa'
export const i19costDeclaredValue = 'Custo pelo valor declarado'
export const i19costPrice = 'Preço de custo'
export const i19countryCode = 'Código do país'
export const i19couponAppliedMsg = 'Cupom de desconto aplicado com sucesso.'
export const i19createTransaction = 'Criar a transação'
export const i19creation = 'Criação'
export const i19credit = 'Crédito'
export const i19creditCard = 'Cartão de credito'
export const i19creditCardBin = 'Número de indetificação do cartão'
export const i19creditCardCompany = 'Emissora do cartao'
export const i19creditCardHolderName = 'Nome no cartão'
export const i19creditCardLastDigits = 'Últimos dígitos do cartão'
export const i19creditorFees = 'Taxa do credor'
export const i19creditorFeesIntermediator = 'Taxa do intermediador com credor'
export const i19creditorFeesOperational = 'Taxa operacional do credor'
export const i19currencyId = 'Identificador da moeda'
export const i19currencySymbol = 'Símbolo monetário'
export const i19custom = 'Personalização'
export const i19customer = 'Cliente'
export const i19customerNotified = 'Cliente notificado pelo evento'
export const i19customerService = 'Serviço ao cliente'
export const i19customFields = 'Campo personalizado'
export const i19customizationAddToPrice = 'Preço da customização'
export const i19customizationAttachment = 'Anexar arquivo customizado'
export const i19customizationChosen = 'Opção customizada pelo cliente'
export const i19customizations = 'Customização'
export const i19customValue = 'Opção personalizada'
export const i19dashboard = 'Painel'
export const i19dateTime = 'Data e hora (ISO 8601)'
export const i19day = 'Dia'
export const i19days = 'Dias'
export const i19danger = 'Perigo'
export const i19declare = 'Declarar'
export const i19declaredValue = 'Valor declarado'
export const i19delete = 'Deletar'
export const i19delivery = 'Entrega'
export const i19deliveryCostOwnHandMsg = 'Custo para o serviço adicional de "mão própria"'
export const i19deliveryInMsg = 'Seu pedido será entregue em até'
export const i19deliveryReceipt = 'Recibo da entrega'
export const i19deliveryReceiptMsg = 'Entregue com aviso de recebimento'
export const i19deliveryTrack = 'Rastreamento de pedido'
export const i19deliveryTime = 'Tempo de entrega'
export const i19deliveryWithOwnHandMsg = 'Entrega com serviço adicional "mão própria"'
export const i19description = 'Descrição'
export const i19desktop = 'Desktop'
export const i19details = 'Detalhes'
export const i19didYouMean = 'Você quis dizer'
export const i19directLinkPayment = 'Link para pagamento'
export const i19disable = 'Desativar'
export const i19discount = 'Desconto'
export const i19discountCoupon = 'Cupom de desconto'
export const i19discountOf = 'Desconto de'
export const i19discountValueMsg = 'Desconto fixo, percentual ou por valor'
export const i19displayName = 'Apelido'
export const i19docCountry = 'País de emissão do documento'
export const i19docNumber = 'Número do documento'
export const i19docs = 'Documentação'
export const i19domain = 'Domínio'
export const i19doPaymentMsg = 'Por favor finalize o pagamento para confirmar sua compra'
export const i19download = 'Baixar'
export const i19downloadTable = 'Baixar tabela'
export const i19edit = 'Editar'
export const i19editing = 'Editando'
export const i19editAdditionalCost = 'Editar custo adicional'
export const i19editComments = 'Editar comentários'
export const i19editDispatchAndFulfillment = 'Editar envio e atendimento'
export const i19editFeatures = 'Editar características'
export const i19editFilters = 'Editar filtros'
export const i19editGtinMpn = 'Editar GTIN e MPN'
export const i19editHtmlDescription = 'Editar descrição HTML'
export const i19editObservationInfo = 'Editar observação do cliente'
export const i19editPaymentDetails = 'Editar detalhes do pagamento'
export const i19editProductDimensions = 'Editar dimensões do produto'
export const i19editSeoFields = 'Editar campos de SEO'
export const i19editVariation = 'Editar variação'
export const i19email = 'E-mail'
export const i19emailAddress = 'Endereço de e-mail'
export const i19emailCartTextMsg = 'Você pode concluí-la agora, enquanto o carrinho ainda está disponível. Não perca essa chance!'
export const i19emailCartTitleMsg = 'Você não finalizou sua compra!'
export const i19emailDeliveredTextMsg = 'Esperamos que tenha gostado da experiência de compra e em breve visite novamente nosso site. O pedido foi entregue no endereço abaixo'
export const i19emailDeliveredTitleMsg = 'Sua compra foi entregue!'
export const i19emailInfoMsg = 'Qualquer atualização no pedido será notificada por e-mail, você também pode acompanhar o andamento pela página'
export const i19emailMarketing = 'E-mail marketing'
export const i19emailProfileNotFoundMsg = 'Nenhum perfil encontrado com o endereço de e-mail'
export const i19emails = 'E-mails'
export const i19emailShippedTextMsg = 'Seu pacote já foi entregue para a transportadora. Para acompanhar o andamento da entrega acesse a página'
export const i19emailShippedTitleMsg = 'Seu pedido está a caminho!'
export const i19empty = 'Vazio'
export const i19emptyCart = 'Carrinho vazio'
export const i19emptyCartMsg = 'Seu carrinho de compras está vazio'
export const i19enabled = 'Habilitado'
export const i19end = 'Final'
export const i19endDate = 'Data final'
export const i19endpoint = 'Endpoint'
export const i19enterYourDocNumber = 'Insira o número do documento'
export const i19enterYourDocNumberMsg = 'Confirme o login com seu documento'
export const i19enterYourEmail = 'Informe seu email'
export const i19enterYourEmailMsg = 'Informe seu email para prosseguir'
export const i19erp = 'ERP'
export const i19error = 'Erro'
export const i19errorMsg = 'Ocorreu um erro, tente novamente ou entre em contato conosco.'
export const i19events = 'Eventos'
export const i19export = 'Exportar'
export const i19exportToCsv = 'Exportar para csv'
export const i19extra = 'Extra'
export const i19external = 'Externo'
export const i19familyName = 'Último nome'
export const i19featuredApps = 'Aplicativos em destaque'
export const i19female = 'Feminino'
export const i19field = 'Campo'
export const i19files = 'Arquivos'
export const i19filter = 'Filtro'
export const i19filterResults = 'Filtrar resultados'
export const i19finalPrice = 'Preço final'
export const i19finalPriceWithAdditional = 'Preço final com adicionais'
export const i19financialStatus = 'Status financeiro'
export const i19followingAddress = 'Para o endereço abaixo'
export const i19for = 'Para'
export const i19free = 'Grátis'
export const i19freebie = 'Brinde'
export const i19freeShipping = 'Frete grátis'
export const i19freeShippingFrom = 'Frete grátis a partir de'
export const i19freight = 'Frete'
export const i19freightCost = 'Custo do frete'
export const i19from = 'De'
export const i19fulfillmentStatus = 'Status de entrega'
export const i19fullName = 'Full name'
export const i19fullscreen = 'Tela cheia'
export const i19gateway = 'Gateway'
export const i19gender = 'Gênero'
export const i19genderX = 'Outros'
export const i19general = 'Geral'
export const i19generateBillet = 'Gerar boleto'
export const i19get = 'Get'
export const i19giftList = 'Lista de presentes'
export const i19giftListAuthors = 'Criadores da lista de presente'
export const i19giftListAuthorsContact = 'Contato do criador da lista de presente'
export const i19giftListDescription = 'Descrição da lista de presente'
export const i19giftListEventDate = 'Data da lista de presente'
export const i19giftListInformation = 'Informações da lista de presente'
export const i19giftListNotificationPurchaseMsg = 'Notificação por e-mail dos produtos comprados da lista de presentes'
export const i19giftListPermalink = 'Link permanente da lista'
export const i19giftListTitle = 'Título da lista de presente'
export const i19giftListValidThru = 'Validade da lista de presente'
export const i19giftListOwnerID = 'ID do dono da lista de presente'
export const i19giftListWaiting = 'Espera da lista de presente'
export const i19giftTo = 'Presente para'
export const i19giftWrap = 'Embrulho de presente'
export const i19gitRepository = 'Repositório do github'
export const i19givenName = 'Primeiro nome'
export const i19goToStore = 'Ir para a loja'
export const i19goToTop = 'Ir pata o topo'
export const i19googleAnalytics = 'Google Analytics'
export const i19googleProductCategoryId = 'ID da categoria no Google'
export const i19gridId = 'ID do grid'
export const i19grids = 'Grades'
export const i19gridName = 'Nome da grade'
export const i19guestCheckoutMsg = 'Se preferir, você também pode continuar comprando como visitante.'
export const i19hasCouponOrVoucherQn = 'Possui cupom ou vale?'
export const i19height = 'Altura'
export const i19hello = 'Olá'
export const i19helloAgain = 'Olá novamente'
export const i19help = 'Ajuda'
export const i19helpful = 'Útil'
export const i19high = 'Alto'
export const i19highestPrice = 'Maior preço'
export const i19highPriority = 'Prioridade máxima'
export const i19holderName = 'Nome do titular'
export const i19home = 'Home'
export const i19icon = 'Ícone'
export const i19id = 'ID'
export const i19identification = 'Identificação'
export const i19identifyYourAccount = 'Identifique-se ou crie sua conta'
export const i19idOfShippingMethod = 'ID da forma de envio'
export const i19image = 'Imagem'
export const i19images = 'Images'
export const i19import = 'Importar'
export const i19in = 'Em'
export const i19inactive = 'Inativo'
export const i19incorrect = 'Incorreto'
export const i19incorrectFormat = 'Formato incorreto'
export const i19info = 'Informação'
export const i19inscriptionNumber = 'Número da inscrição'
export const i19insert = 'Inserir'
export const i19install = 'Instalar'
export const i19installed = 'Instalado'
export const i19installedApps = 'Apps instalados'
export const i19installingApp = 'Instalando aplicativo'
export const i19installment = 'Parcelamento'
export const i19installments = 'Parcelamentos'
export const i19installNow = 'Instalar agora'
export const i19inStock = 'Em estoque'
export const i19inStockAt = 'Disponível em'
export const i19interestFree = 'Sem juros'
export const i19intermediator = 'Intermediador'
export const i19invalidCard = 'Cartão inválido'
export const i19invalidCardMsg = 'Não foi possível validar este cartão, por favor verifique os dados ou tente novamente mais tarde.'
export const i19invalidCouponMsg = 'O cupom de desconto inserido é inválido.'
export const i19invalidLoginInfoMsg = 'Login inválido, por favor verifique os dados informados.'
export const i19inventory = 'Inventório'
export const i19inventoryHistory = 'Histórico de alteração do inventório'
export const i19invoice = 'Fatura'
export const i19invoices = 'Faturas'
export const i19isFilter = 'É filtro'
export const i19isNotYou = 'Não é você'
export const i19item = 'Item'
export const i19items = 'Itens'
export const i19itemsFound = 'Itens encontrados'
export const i19jurifical = 'Jurídica'
export const i19just = 'Apenas'
export const i19keywords = 'Palavras chave'
export const i19label = 'Rótulo'
export const i19LabelOfCustomization = 'Rótulo da customização'
export const i19last = 'Último'
export const i19lastOptions = 'Últimas unidades disponíveis'
export const i19lastPurchase = 'Última Compra'
export const i19lastSearchedTerms = 'Últimos produtos visitados'
export const i19lastVisitedProducts = 'Últimos produtos visitados'
export const i19launch = 'Lançamento'
export const i19launching = 'Lançando'
export const i19length = 'Comprimento'
export const i19lineAddress = 'Endereço completo'
export const i19list = 'Listar'
export const i19listOfInvoices = 'List of invoices'
export const i19listOfPayments = 'Listar formas de pagamento'
export const i19load = 'Carregar'
export const i19loadDataErrorMsg = 'Não foi possível carregar os dados da API, por favor verifique sua conexão.'
export const i19loadProductErrorMsg = 'Não foi possível carregar informações do produto, por favor verifique sua conexão.'
export const i19locale = 'Idioma do cliente'
export const i19login = 'Login'
export const i19loginEnabled = 'Login habilitado'
export const i19loginErrorMsg = 'Houve um erro ao tentar o login, por favor tente novamente ou tente outra opção.'
export const i19logo = 'Logo'
export const i19logout = 'Sair'
export const i19low = 'Baixo'
export const i19lowestPrice = 'Menor preço'
export const i19loyaltyPoints = 'Pontos do programa de fidalidade'
export const i19loyaltyPointsName = 'Nome do programa de fidalidade'
export const i19loyaltyPointsPointsValue = 'Número de pontos recebidos pelo programa de fidelidade'
export const i19madeBy = 'Feito por'
export const i19mainEmail = 'E-mail principal'
export const i19male = 'Masculino'
export const i19manageStock = 'Controle de estoque'
export const i19manageYourPurchaseHistory = 'Gerenciar seu histórico de compras'
export const i19marketing = 'Marketing'
export const i19marketplace = 'Marketplace'
export const i19marketplaces = 'Marketplaces'
export const i19media = 'Mídia'
export const i19mediaGallery = 'Galeria de imagens'
export const i19measurement = 'Dimensão do produto'
export const i19menu = 'Menu'
export const i19metafields = 'Metafields'
export const i19metafieldsMsg = 'Lista de atributos customizados'
export const i19metaTagDescription = 'Meta description tag'
export const i19middleName = 'Sobrenome do meio'
export const i19minQuantity = 'Quantidade mínima'
export const i19mlCategoryId = 'ID da categoria no ML'
export const i19mobile = 'Mobile'
export const i19mobileLink = 'Links para celular'
export const i19modules = 'Módulos'
export const i19month = 'Mês'
export const i19mostPopular = 'Mais populares'
export const i19mostRelevant = 'Mais relevantes'
export const i19myAccount = 'Minha conta'
export const i19myCart = 'Meu carrinho'
export const i19myOrders = 'Meus pedidos'
export const i19myShoppingCart = 'Meu carrinho de compras'
export const i19name = 'Nome'
export const i19nameOnCard = 'Nome impresso cartão'
export const i19namespace = 'Namespace'
export const i19namespaceMsg = 'String para ajudar a distinguir quem (ou qual aplicativo) criou e pode usa-lo'
export const i19nearTo = 'Referência do endereço'
export const i19needHelpQn = 'Precisa de ajuda?'
export const i19new = 'Novo'
export const i19newAddress = 'Novo endereço'
export const i19newPassword = 'Nova senha'
export const i19newPriceRange = 'Nova faixa de preço'
export const i19newsletter = 'Newsletter'
export const i19newsletterReport = 'Relatório de newsletter'
export const i19next = 'Próximo'
export const i19nickname = 'Apelido'
export const i19no = 'Não'
export const i19noAdditional = 'Sem adicional'
export const i19noAppsAvailable = 'Não há aplicativos disponíveis'
export const i19noBrand = 'Nenhuma marca encontrada'
export const i19noCategory = 'Nenhuma categoria encontrada'
export const i19noCollection = 'Nenhuma coleção encontrada'
export const i19noGrid = 'Nenhuma grade encontrada'
export const i19noNumber = 'S/N'
export const i19noOrder = 'Nenhum pedido encontrado'
export const i19noProduct = 'Nenhum produto encontrado'
export const i19noProfileFoundWithEmail = 'Nenhum perfil encontrado pelo e-mail'
export const i19noResultsFor = 'Nenhum produto encontrado para'
export const i19normal = 'Normal'
export const i19notifications = 'Notificações'
export const i19notified = 'Notifificado'
export const i19notifiedAdmins = 'Notificação do admin'
export const i19notifiedAdminsMsg = 'Lista de admnistradores que verificaram a mudança de status'
export const i19notifyAboutOrders = 'Notificar sobre o andamento do pedido'
export const i19notes = 'Informação adicional'
export const i19noUser = 'Nenhum usuário encontrado'
export const i19number = 'Número'
export const i19oauthOnPopup = 'Continue o login no pop-up'
export const i19of = 'De'
export const i19ofDiscount = 'De desconto'
export const i19on = 'No'
export const i19onFreight = 'No frete'
export const i19onFollowingAddress = 'No endereço abaixo'
export const i19only = 'Apenas'
export const i19open = 'Aberto'
export const i19openAt = 'Aberto em'
export const i19openCart = 'Abrir carrinho'
export const i19openGallery = 'Abrir galería'
export const i19operational = 'Operacional'
export const i19option = 'Opção'
export const i19optionChosen = 'Opção escolhida'
export const i19options = 'Opções'
export const i19or = 'Ou'
export const i19order = 'Pedido'
export const i19orderDetails = 'Detalhes do pedido'
export const i19orders = 'Pedidos'
export const i19orderCreated = 'Pedido criado'
export const i19orderConfirmationMsg = 'Seu pedido foi confirmado, obrigado pela preferência'
export const i19ordersCount = 'Total de pedidos'
export const i19orderCode = 'Código do pedido'
export const i19orderItems = 'Itens do pedido'
export const i19orderNumber = 'Número do pedido'
export const i19orderObservations = 'Observações do pedido'
export const i19orderStatus = 'Status do pedido'
export const i19orderValue = 'Valor do pedido'
export const i19ordersTotalValue = 'Valor total de pedidos'
export const i19organization = 'Organização'
export const i19orProceedWith = 'Ou prossiga com'
export const i19otherCustomers = 'Outros clientes'
export const i19otherCustomersMsg = 'Disponível para outros clientes'
export const i19outOfStock = 'Sem estoque'
export const i19ownHand = 'Mão própria'
export const i19ownHandCost = 'Custo por mão própria'
export const i19package = 'Pacote'
export const i19packageInformation = 'Informação do pacote'
export const i19packageDimensions = 'Dimensões do objeto da remessa'
export const i19packageDimensionsInformation = 'Informação das dimensões do objeto da remessa'
export const i19packageWeight = 'Package weight'
export const i19pageLoaded = 'Página carregada'
export const i19paid = 'Pago'
export const i19paidTextMsg = 'Recebemos seu pagamento e estamos trabalhando para que você receba seu(s) produto(s) o mais rápido possível.'
export const i19parcelIn = 'Parcelar em'
export const i19parentCategory = 'Categoria pai'
export const i19partner = 'Parceiro'
export const i19partners = 'Parceiros'
export const i19partnersProgram = 'Programa de parceiros'
export const i19passwordChangedSuccessfully = 'Senha alterada com sucesso'
export const i19patch = 'Patch'
export const i19payer = 'Pagador'
export const i19payment = 'Pagamento'
export const i19paymentConfirmed = 'Pagamento confirmado'
export const i19paymentDetails = 'Detalhes do pagamento'
export const i19paymentError = 'Erro no pagamento'
export const i19paymentErrorMsg = 'Não foi possível aprovar a compra, por favor verifique os dados ou tente com outra forma de pagamento.'
export const i19paymentLink = 'Link de pagamento'
export const i19paymentMethod = 'Forma de pagamento'
export const i19paymentMethods = 'Formas de pagamento'
export const i19paymentMethodLabel = 'Nome da forma de pagamento'
export const i19paymentOptions = 'Opções de pagamento'
export const i19paymentRealized = 'Pagamento realizado'
export const i19personalRegistration = 'Pessoa física'
export const i19permalink = 'Link permanente'
export const i19phone = 'Telefone'
export const i19phones = 'Telefones'
export const i19photo = 'Foto'
export const i19photos = 'Fotos'
export const i19pickup = 'Coleta'
export const i19picture = 'Imagem'
export const i19pictures = 'Imagens'
export const i19popularProducts = 'Produtos populares'
export const i19popup = 'Popup'
export const i19post = 'Post'
export const i19posted = 'Postado'
export const i19postingDeadline = 'Período final para entrega de pacotes'
export const i19postingIn = 'Seu pedido será enviado em até'
export const i19previous = 'Anterior'
export const i19price = 'Preço'
export const i19priceAlteration = 'Alteração de preço'
export const i19priceEffectiveDate = 'Validade da promoção'
export const i19priceEffectiveDateEnd = 'Data final da promoção (ISO 8601)'
export const i19priceEffectiveDateStar = 'Data de início da promoção (ISO 8601)'
export const i19priceRange = 'Price range'
export const i19priceTo = 'Price até'
export const i19pricing = 'Precificação'
export const i19printBillet = 'Imprimir boleto'
export const i19privacy = 'Privacidade'
export const i19privacyPolicy = 'Política de privacidade'
export const i19private = 'Privado'
export const i19privateMetafields = 'Metafields privados'
export const i19privateMetafieldsMsg = 'Lista de atributos personalizados, ocultos por padrão e visíveis para os compradores'
export const i19product = 'Produto'
export const i19productDescription = 'Descrição do produto'
export const i19productId = 'ID do produto'
export const i19productImages = 'Imagens do produto'
export const i19productSpecifications = 'Especificações do produto'
export const i19productionTime = 'Prazo para produção ou manuseio do produto encomendado'
export const i19productionTimeCumulative = 'Se o o tempo de produção é acumulativo por unidade'
export const i19productionTimeDaysMsg = 'Número de dias para postar o produto após a compra, prazo para produção ou manuseio'
export const i19productionTimeWorkingDays = 'Tempo de produção em dias úteis'
export const i19productName = 'Nome do produto'
export const i19products = 'Produtos'
export const i19productsAdded = 'Produtos adicionados'
export const i19productsAddedToCart = 'Produtos adicionados ao carrinho'
export const i19productsPurchased = 'Produtos comprados pelos clientes'
export const i19profile = 'Perfil'
export const i19profileNotFound = 'Nenhum perfil encontrado com o endereço de e-mail'
export const i19province = 'Nome do estado'
export const i19provinceCode = 'UF'
export const i19put = 'Put'
export const i19quantity = 'Quantidade'
export const i19random = 'Aleatório'
export const i19rating = 'Avaliação'
export const i19read = 'Lido'
export const i19receipt = 'Recibo'
export const i19receiptPrice = 'Preço do recibo'
export const i19receivedOrder = 'Recebemos seu pedido'
export const i19receiveNewsletter = 'Receber newsletter'
export const i19recipient = 'Destinatário'
export const i19recommendations = 'Recomendações'
export const i19recommendedForYou = 'Recomendados para você'
export const i19recommendedProducts = 'Produtos recomendados'
export const i19redirectToPayment = 'Redirecionamento de pagamento'
export const i19reference = 'Referência'
export const i19referenceCode = 'Código de referência'
export const i19referral = 'Cliente convidado por'
export const i19referringSite = 'Site de referência'
export const i19refine = 'Refinar'
export const i19refineSearch = 'Refinar busca'
export const i19registerDate = 'Data de cadastro'
export const i19registerToBuy = 'Registre para comprar'
export const i19registerToBuyMsg = 'Complete seu cadastro para prosseguir com a compra'
export const i19registration = 'Cadastro'
export const i19relatedApps = 'Aplicativos relacionados'
export const i19relatedProduct = 'Produtos relacionados'
export const i19relatedSearch = 'Consultas relacionadas'
export const i19relevance = 'Relevância'
export const i19remove = 'Remover'
export const i19removed = 'Removido'
export const i19reopenOrder = 'Reabrir pedido'
export const i19require = 'Exigir'
export const i19required = 'Obrigatório'
export const i19requiredEmail = 'E-mail obrigatório'
export const i19requiredEmailMsg = 'Preenchimento de e-mail obrigatório'
export const i19requiredField = 'Campo obrigatório'
export const i19resource = 'Recurso'
export const i19resourceId = 'ID do recurso'
export const i19results = 'Resultados'
export const i19resultsFor = 'Resultados para'
export const i19retail = 'Retenção'
export const i19retry = 'Tentar novamente'
export const i19reviews = 'Avaliações de Clientes'
export const i19safeEnvMsg = 'Ambiente 100% seguro'
export const i19sales = 'Vendas'
export const i19salesPrice = 'Preço de venda'
export const i19salesChannels = 'Canais de vendas'
export const i19save = 'Salvar'
export const i19saveBrand = 'Salvar marca'
export const i19saveCart = 'Salvar carrinho'
export const i19saveCategory = 'Salvar categoria'
export const i19saveClient = 'Salvar cliente'
export const i19saved = 'Salvo'
export const i19saveCollection = 'Salvar coleção'
export const i19saveGrid = 'Salvar grade'
export const i19saveProduct = 'Salvar produto'
export const i19saveText = 'Salvar texto'
export const i19scheduledDelivery = 'Entrega programada'
export const i19search = 'Buscar'
export const i19searchAgain = 'Buscar novamente'
export const i19searchEngineListing = 'Listagem em motores de busca'
export const i19searchingFor = 'Buscando por'
export const i19searchItems = 'Buscar itens'
export const i19searchOfflineErrorMsg = 'Não foi possível realizar a busca, por favor verique sua conexão.'
export const i19searchProducts = 'Buscar produtos'
export const i19securityCode = 'Código de segurança'
export const i19seeAll = 'Ver todos'
export const i19seeAllApps = 'Ver todos aplicativos'
export const i19seeAllThemes = 'Ver todos temas'
export const i19seeAll$1Category = 'Ver toda a categoria $1'
export const i19seeCart = 'Ver carrinho'
export const i19seeMore = 'Ver mais'
export const i19seeMoreCategory = 'Veja mais categorias'
export const i19seeMoreInfo = 'Veja mais informações'
export const i19seeOrder = 'Visualizar pedido'
export const i19seeShoppingCart = 'Ver carrinho de compras'
export const i19select = 'Selecionar'
export const i19selected = 'Selecionado'
export const i19selectVariation = 'Selecionar variação'
export const i19selectVariationMsg = 'Por favor selecione uma opção em cada campo acima'
export const i19seller = 'Vendedor'
export const i19sellerRecommendations = 'Recomendações do vendedor'
export const i19sellerRecommendationsProducts = 'Lista de produtos recomendados'
export const i19sellerRecommendationsTitle = 'Título da coleção recomendada'
export const i19sellerStatus = 'Status do vendedor'
export const i19sellerStatusMsg = 'Status do pedido criado pelo vendedor'
export const i19send = 'Enviar'
export const i19senderFrom = 'Endereço do remetente'
export const i19seo = 'SEO'
export const i19share = 'Compartilhar'
export const i19shareOnFacebook = 'Compartilhar no Facebook'
export const i19shareOnWhatsapp = 'Compartilhar no Whatsapp'
export const i19shipped = 'Enviado'
export const i19shippedBy = 'Enviado por'
export const i19shipping = 'Entrega'
export const i19shippingAdditionalPrice = 'Preço adicional do envio'
export const i19shippingAddress = 'Endereço de entrega'
export const i19shippingCustomFields = 'Campos personalizados de envio'
export const i19shippingDiscount = 'Desconto no envio'
export const i19shippingInvoices = 'Fatura da remessa'
export const i19shippingMethod = 'Método de envio'
export const i19shippingMethodLabel = 'Rótulo do método de envio'
export const i19shippingNotes = 'Notas sobre o envio'
export const i19shippingNotesMsg = 'Informação adicional da forma de envio'
export const i19shippingStatus = 'Status do envio'
export const i19shippingTag = 'Etiqueta de envio'
export const i19shippingTags = 'Etiquetas de envio'
export const i19shippingTaxes = 'Taxas de envio'
export const i19shippingTaxesMsg = 'Lista de serviços adicionais para esta remessa'
export const i19shippingTo = 'Envio para'
export const i19shippingTotalCost = 'Custo total do envio'
export const i19shopByCategory = 'Compre por categorias'
export const i19shopByFranchise = 'Compre por marcas'
export const i19shopNow = 'Compre agora'
export const i19shoppingCart = 'Carrinho de compras'
export const i19short = 'Curta'
export const i19shortDescription = 'Descrição curta'
export const i19show = 'Mostrar'
export const i19showDescription = 'Mostrar toda descrição'
export const i19showReview = 'Mostrar toda avaliação'
export const i19signIn = 'Entrar'
export const i19signInWith = 'Entrar com'
export const i19signInWithAnotherEmail = 'Entrar com outro e-mail'
export const i19signUp = 'Cadastrar'
export const i19signUpWith = 'Cadastrar via'
export const i19size = 'Tamanho'
export const i19sku = 'Sku'
export const i19slug = 'Slug'
export const i19socialLogin = 'Login social'
export const i19socialMedia = 'Mídia social'
export const i19source = 'Origem'
export const i19sourceName = 'Nome da origem do pedido'
export const i19sort = 'Ordenar'
export const i19sortBy = 'Ordenar por'
export const i19subscribe = 'Assinar'
export const i19submit = 'Enviar'
export const i19suggestedProducts = 'Produtos sugeridos'
export const i19specifications = 'Especificações'
export const i19staffNotes = 'Observação do admnistrador'
export const i19staffSignature = 'Criado pelo admnistrador'
export const i19star = 'Estrela'
export const i19startDate = 'Data inicial'
export const i19state = 'Estado'
export const i19status = 'Status'
export const i19statusLink = 'Link de status do pedido'
export const i19statusMobileLink = 'Link de status do pedido para mobile'
export const i19street = 'Rua'
export const i19store = 'Loja'
export const i19storefront = 'Storefront'
export const i19subresource = 'Sub recurso'
export const i19subresourceId = 'ID do sub recurso'
export const i19subtitle = 'Subtítulo para SEO'
export const i19subtotal = 'Subtotal'
export const i19success = 'Sucesso'
export const i19summary = 'Resumo'
export const i19support = 'Suporte'
export const i19table = 'Tabela'
export const i19tax = 'Imposto'
export const i19taxExempt = 'Isento de imposto'
export const i19termSearched = 'Termo pesquisado'
export const i19test = 'Teste'
export const i19thanks = 'Obrigado!'
export const i19thanksForPurchase = 'Agradecemos por sua compra!'
export const i19theme = 'Tema'
export const i19themes = 'Temas'
export const i19ticketCode = 'Código de barras do boleto'
export const i19title = 'Título'
export const i19titleTag = 'Title tag'
export const i19to = 'Por'
export const i19toEarn = 'Para ganhar'
export const i19today = 'Hoje'
export const i19token = 'Token'
export const i19total = 'Total'
export const i19totalCancelled = 'Total cancelado'
export const i19totalCancelledMsg = 'Valor total de compras canceladas'
export const i19totalResultsFor = 'Produtos encontrados para'
export const i19totalSpent = 'Valor total de compras confirmadas'
export const i19trackingCodes = 'Códigos de rastreamento'
export const i19transactionCode = 'Código da transação'
export const i19transactionId = 'ID da transação'
export const i19transactionItems = 'Lista de itens da transação'
export const i19transactionStatus = 'Status da transação'
export const i19transactionStatusMsg = 'Status da transação com data e hora'
export const i19transactionType = 'Tipo da transação'
export const i19trendingApps = 'Aplicativos populares'
export const i19triggers = 'Triggers'
export const i19triggersMsg = 'Lista de eventos que chamam este procedimento'
export const i19tryAgain = 'Tente novamente'
export const i19type = 'Tipo'
export const i19unable = 'Não disponível'
export const i19unableToInstallApp = 'Não foi possível instalar o aplicativo'
export const i19unableToUninstallApp = 'Não foi possível desinstalar o aplicativo'
export const i19unavailable = 'Indisponível'
export const i19uninstall = 'Desinstalar'
export const i19uninstallingApp = 'Desinstalando aplicativo'
export const i19uninstallingAppWithSuccess = 'Desinstalando aplicativo com sucesso'
export const i19units = 'Unidades'
export const i19unitsInStock = 'Unidades em estoque'
export const i19unlimited = 'Ilimitado'
export const i19unsubscribe = 'Cancelar assinatura'
export const i19update = 'Atualização'
export const i19updatedAt = 'Atualizado em'
export const i19upload = 'Upload'
export const i19uploadTable = 'Carregar tabela'
export const i19upTo = 'Até'
export const i19user = 'Usuário'
export const i19userFound = 'Usuário encontrado'
export const i19username = 'Username'
export const i19usersFound = 'Usuários encontrados'
export const i19utm = 'Utm'
export const i19utmCampaign = 'Nome da campanha'
export const i19utmContent = 'Conteúdo da campanha'
export const i19utmMedium = 'Mídia da campanha'
export const i19utmSource = 'Origem do utm'
export const i19utmTerm = 'Termo da campanha'
export const i19url = 'Url'
export const i19valid = 'Validade'
export const i19validate = 'Validar'
export const i19validThru = 'Válido até'
export const i19value = 'Valor'
export const i19variation = 'Variação'
export const i19variationId = 'ID da variação'
export const i19variationName = 'Nome da variação'
export const i19variations = 'Variações'
export const i19verified = 'Verificado'
export const i19version = 'Versão'
export const i19versionDate = 'Data da versão'
export const i19video = 'Vídeo'
export const i19videos = 'Vídeos'
export const i19visible = 'Visível'
export const i19visibleProducts = 'Produtos visíveis'
export const i19visitor = 'Visitante'
export const i19visitorCheckout = 'Você também pode comprar como visitante se preferir'
export const i19warning = 'Aviso'
export const i19wasAnErrorOnLogin = 'Houve um erro ao tentar o login, por favor tente novamente ou selecione outra opção'
export const i19webhooks = 'Webhook'
export const i19webhooksMsg = 'Lista de notificações a serem enviadas'
export const i19webhooksApiMsg = 'Notifificações que deverão ser enviadas para API'
export const i19webhooksApiExternalApiMsg = 'Use esta propriedade se o webhook for para qualquer API externa (não api.e-com.plus)'
export const i19webhooksApiStoreApiMsg = 'Use esta propriedade se o webhook for armazenar API (api.e-com.plus)'
export const i19webhooksMapBodyMsg = 'Objeto a enviar, é possível usar variáveis ​​como valores de propriedades'
export const i19webhooksSendBodyMsg = 'Se verdadeiro, o body é enviado na notificação. Se map_body é indefinido, objeto do trigger será enviado'
export const i19weight = 'Peso'
export const i19weFrom = 'Nós da'
export const i19welcome = 'Boas vindas'
export const i19welcomeTextMsg = 'Ficamos felizes com seu cadastro. Dê uma olhada em nossos produtos e aproveite as ofertas!'
export const i19weRecommendToYou = 'Nós recomendamos para você'
export const i19weUseYourDataToMsg = 'Usaremos seus dados com segurança e responsabilidade para'
export const i19widgets = 'Widgets'
export const i19width = 'Largura'
export const i19willReceiveMsg = 'Você receberá os produtos em até'
export const i19with = 'Com'
export const i19withoutInstallmentRates = 'Sem taxas de parcelamento'
export const i19write = 'Escreva'
export const i19writeReview = 'Escreva uma avaliação'
export const i19workingDays = 'Dias úteis'
export const i19year = 'Ano'
export const i19yes = 'Yes'
export const i19yourInstalledApps = 'Seus apps instalados'
export const i19zipCode = 'CEP'
export const i19zipCodeRange = 'Faixa de CEP'

export const i19CancelReason = {
  customer: 'Cancelado pelo cliente',
  fraud: 'Cancelado por fraude',
  inventory: 'Cancelado por falta de estoque',
  declined: 'Cancelado pela empresa de cartão de crédito',
  other: 'Outro motivo'
}

export const i19ChannelType = {
  ecommerce: 'E-commerce',
  mobile: 'Mobile',
  pos: 'PDV',
  button: 'Botão',
  facebook: 'Facebook',
  chatbot: 'Chatbot'
}

export const i19CommodityType = {
  physical: 'Físico',
  digital: 'Digital'
}

export const i19ProductCondition = {
  new: 'Novo',
  refurbished: 'Recondicionado',
  used: 'Usado',
  not_specified: 'Não especificado'
}

export const i19DiscountApplyAt = {
  total: 'Total',
  subtotal: 'Subtotal',
  freight: 'Frete'
}

export const i19DiscountType = {
  percentage: 'Percentual',
  fixed: 'Fixo'
}

export const i19FinancialStatus = {
  pending: 'Aguardando pagamento',
  under_analysis: 'Pagamento em análise',
  authorized: 'Pagamento autorizado',
  unauthorized: 'Pagamento não autorizado',
  partially_paid: 'Parcialmente pago',
  paid: 'Pagamento aprovado',
  dispute: 'Pagamento em disputa',
  partially_refunded: 'Pagamento parcialemente devolvido',
  refunded: 'Pagamento devolvido',
  voided: 'Pagamento cancelado',
  unknown: 'Situação do pagamento desconhecida'
}

export const i19FinancialStatusMsg = {
  pending: 'Seu pedido está',
  under_analysis: 'Seu pedido está com',
  authorized: 'Seu pedido está com',
  unauthorized: 'Seu pedido está com',
  partially_paid: 'Seu pedido está',
  paid: 'Seu pedido está com',
  dispute: 'Seu pedido está com',
  partially_refunded: 'Seu pedido está com',
  refunded: 'Seu pedido está com',
  voided: 'Seu pedido está com',
  unknown: 'Seu pedido está com'
}

export const i19FulfillmentStatus = {
  ready_for_shipping: 'Pronto para envio',
  shipped: 'Enviado',
  delivered: 'Entregue',
  invoice_issued: 'NF emitida',
  in_production: 'Em produção',
  in_separation: 'Em separação',
  partially_shipped: 'Parte enviado',
  partially_delivered: 'Parte entregue',
  returned_for_exchange: 'Retorno da troca',
  received_for_exchange: 'Recebido para troca',
  returned: 'Devolvido'
}

export const i19FulfillmentStatusMsg = {
  ready_for_shipping: 'Seu pedido está',
  shipped: 'Seu pedido foi',
  delivered: 'Seu pedido foi',
  invoice_issued: 'Sua',
  in_production: 'Seu pedido está',
  in_separation: 'Seu pedido está',
  partially_shipped: 'Seu pedido foi',
  partially_delivered: 'Seu pedido foi',
  returned_for_exchange: 'Seu pedido tem',
  received_for_exchange: 'Seu pedido foi',
  returned: 'Seu pedido foi'
}

export const i19Gender = {
  f: 'Feminino',
  m: 'Masculino',
  x: 'X'
}

export const i19InscriptionType = {
  state: 'Estadual',
  municipal: 'Municipal'
}

export const i19OrderStatus = {
  open: 'Pedido aberto',
  closed: 'Pedido finalizado',
  cancelled: 'Cancelado'
}

export const i19PaymentsHistoryStatus = {
  pending: 'Aguardando pagamento',
  under_analysis: 'Pagamento em análise',
  authorized: 'Pagamento autorizado',
  unauthorized: 'Pagamento não autorizado',
  partially_paid: 'Parcialmente pago',
  paid: 'Pagamento aprovado',
  dispute: 'Pagamento em disputa',
  partially_refunded: 'Pagamento parcialemente devolvido',
  refunded: 'Pagamento devolvido',
  voided: 'Pagamento cancelado',
  unknown: 'Situação do pagamento desconhecida'
}

export const i19PhoneType = {
  home: 'Casa',
  personal: 'Pessoal',
  work: 'Trabalho',
  other: 'Outro'
}

export const i19RegistryType = {
  p: 'Pessoa física',
  j: 'Pessoa jurídica'
}

export const i19ShippingLinesStatus = {
  ready_for_shipping: 'Pronto para envio',
  shipped: 'Enviado',
  delivered: 'Entregue',
  invoice_issued: 'NF emitida',
  in_production: 'Em produção',
  in_separation: 'Em separação',
  partially_shipped: 'Parte enviado',
  partially_delivered: 'Parte entregue',
  returned_for_exchange: 'Retorno da troca',
  received_for_exchange: 'Recebido para troca',
  returned: 'Devolvido'
}

export const i19StateRegister = {
  invited: 'Convidado',
  registered: 'Registrado',
  declined: 'Recusado'
}

export const i19TransactionsType = {
  payment: 'Pagamento',
  recurrence: 'Assinatura'
}

export const i19ApiActions = {
  create: 'Criar',
  change: 'Alterar',
  delete: 'Deletar'
}

export const i19StoreApiResources = {
  authentications: 'Autenticações',
  products: 'Produtos',
  categories: 'Categorias',
  brands: 'Marcas',
  collections: 'Coleções',
  grids: 'Grades',
  customers: 'Clientes',
  carts: 'Carrinhos',
  orders: 'Pedidos',
  applications: 'Aplicações',
  stores: 'Lojas',
  procedures: 'Procedimentos',
  triggers: 'Triggers'
}
